import { OrganizationModel } from '../organization';

/** Contract consumed by PerfilComponent; mirrors cloudclass-auth's ProfileResponse (GET /auth/profile). */
export class UserModel {
  id: string = '';
  name: string = '';
  email: string = '';
  password: string = '';
  avatarUrl: string | null = null;
  verify: boolean = false;
  admin: boolean = false;
  roles: string[] = [];
  identities: string[] = [];
  hasPassword: boolean = true;
  whatsappPhone: string | null = null;
  pendingPhone: string | null = null;
  mfaEnabled: boolean = false;
  organization: OrganizationModel | null = null;
  activeUnitId: string | null = null;
  provisioning: string = '';
}

export class UserListModel {
  id: string = '';
  email: string = '';
}
